module.exports = __webpack_public_path__ + "static/img/8.ecc834e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/sp/8.png
// module id = tJbl
// module chunks = 0